<template>
  <div class="sf_section">
    <img src="@/assets/recruit.svg" alt="MIKの採用フロー" class="sf_title_img">

    <div class="sf_flow">

      <div class="sf_step">
        <div class="sf_step_num">STEP 1</div>
        <div class="sf_step_body">
          <div class="sf_step_title">面談希望フォームを送信</div>
          <div class="sf_step_desc">このページ下部のフォームからお申し込みください。</div>
        </div>
      </div>

      <div class="sf_arrow">▼</div>

      <div class="sf_step">
        <div class="sf_step_num">STEP 2</div>
        <div class="sf_step_body">
          <div class="sf_step_title">弊社担当者よりご連絡</div>
          <div class="sf_step_desc">日程調整のご連絡をお送りします。</div>
        </div>
      </div>

      <div class="sf_arrow">▼</div>

      <div class="sf_step">
        <div class="sf_step_num">STEP 3</div>
        <div class="sf_step_body">
          <div class="sf_step_title">書類提出</div>
          <div class="sf_step_desc">履歴書・職務経歴書をご提出ください。</div>
        </div>
      </div>

      <div class="sf_arrow">▼</div>

      <div class="sf_step">
        <div class="sf_step_num">STEP 4</div>
        <div class="sf_step_body">
          <div class="sf_step_title">面談 <span class="sf_note">（原則１回）</span></div>
          <div class="sf_step_desc">担当者と直接お話しします。</div>
        </div>
      </div>

      <div class="sf_arrow">▼</div>

      <div class="sf_step sf_step_last">
        <div class="sf_step_num">STEP 5</div>
        <div class="sf_step_body">
          <div class="sf_step_title">合否連絡</div>
          <div class="sf_step_desc">メールまたは電話にてご連絡します。</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.sf_section {
  width: 100%;
  padding: 48px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
}

.sf_title_img {
  width: 360px;
  max-width: 90%;
  margin-bottom: 32px;
}

.sf_flow {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 600px;
}

.sf_step {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
  background: #fff;
  border: 2px solid #e0eef5;
  border-radius: 12px;
  padding: 20px 28px;
  box-shadow: 0 2px 8px rgba(12, 192, 223, 0.07);
  box-sizing: border-box;
}

.sf_step_last {
  border-color: #0cc0df;
  background: linear-gradient(135deg, #f0fbfe 0%, #e6f7fb 100%);
}

.sf_step_num {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.06em;
  color: #0cc0df;
  white-space: nowrap;
  background: rgba(12, 192, 223, 0.1);
  border-radius: 6px;
  padding: 8px 14px;
}

.sf_step_body {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.sf_step_title {
  font-size: 18px;
  font-weight: 700;
  color: #1a2a3a;
}

.sf_note {
  font-size: 14px;
  font-weight: 400;
  color: #7a99aa;
}

.sf_step_desc {
  font-size: 15px;
  color: #5a7080;
  line-height: 1.6;
}

.sf_arrow {
  color: #0cc0df;
  font-size: 20px;
  margin: 4px 0;
  opacity: 0.6;
}
</style>